import React from 'react';
import './App.css';
import Header from './Components/Header';
import { Route, Routes } from 'react-router-dom';
import Addcartitem from './Components/Addcartitem';
import Home from './Components/Home';
import ButyNow from './Components/ButyNow';
import Login from './Components/Login';

function App() {

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/cart' element={<Addcartitem />} />
        <Route path='/cart/buy' element={<ButyNow />}></Route>
      </Routes>
    </div >
  );
}

export default App;
